import React from 'react';
import PropTypes from 'prop-types';
import FormModal from "../../../components/common/modals/FormModal";
import {useFragment, useMutation} from "react-relay";
import {allLanguagesDropdown} from "../../../relay/Fragments";
import {createOptions} from "../../../helpers/utils";
import graphql from "babel-plugin-relay/macro";
import * as yup from "yup";
import dayjs from "dayjs";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema} from "../../../helpers/bandedUtils";

const EditFacilityLocationLanguageModal = ({showModal, onClose, selectedLanguage, languages}) => {
    const mutation = graphql`
        mutation EditFacilityLocationLanguageModalMutation($id: ID!, $languageId: ID!, $seq: Int!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
            facilityLocation {
                modifyLanguage(input: {facilityLocationLanguageId: $id, languageId: $languageId, seq: $seq, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                    facilityLocationLanguage {
                        id
                        facilityLocation {
                            languages {
                                ...FacilityLocationLanguages_Languages
                            }}}}}}`
    const allLanguages = createOptions(useFragment(allLanguagesDropdown, languages), 'id', 'name');
    const [commitMutation, isInFlight] = useMutation(mutation);
    const effectiveFrom = selectedLanguage?.effectiveFrom ? dayjs(selectedLanguage?.effectiveFrom).toDate() : '';
    const effectiveTo = selectedLanguage?.effectiveTo ? dayjs(selectedLanguage?.effectiveTo).toDate() : '';
    const defaultValues = {
        id: selectedLanguage?.id,
        languageId: selectedLanguage?.language.id,
        effectiveFrom: effectiveFrom,
        effectiveTo: effectiveTo,
        seq: selectedLanguage?.seq
    };
    const schema = bandedSchema.shape({
        languageId: yup.string().required("Language is required"),
        seq: yup.number().required("Seq is required")
    });

    const methods = useForm({values: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data},
            onCompleted: (data) => {
                if(data.facilityLocation) {
                    toast.success("Language has been updated")
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"Update Language"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
        >
            <HorizontalFormSelect options={allLanguages} controlId={"languageId"} label={"Language"} />
            <HorizontalFormInput controlId={"seq"} label={"Seq"} type={"number"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
EditFacilityLocationLanguageModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedLanguage: PropTypes.object.isRequired,
    languages: PropTypes.array.isRequired,
}
export default EditFacilityLocationLanguageModal